import React from 'react';

export const mailChimp = {
    pass: '484a3a1e06f432d18a04936dd5a2c64e-us8',
    listId: '1cdece3df5'
};

export const firebaseVar = {
    apiKey: 'AIzaSyBGxtQ6eiP2VMXxTAf_0TUbfcqti7IpAg0',
    authDomain: 'learn-cambridge-audio.firebaseapp.com',
    databaseURL: 'https://learn-cambridge-audio.firebaseio.com',
    projectId: 'learn-cambridge-audio',
    storageBucket: 'learn-cambridge-audio.appspot.com',
    messagingSenderId: '560250567729',
};




// WEBPACK FOOTER //
// ./src/utility/apiVar.js